import { twMerge } from "tailwind-merge";

export default function Divider({ className }: { className?: string }) {
  return (
    <div
      className={twMerge("min-w-full border-b-2 border-pink-300", className)}
    ></div>
  );
}
